<template>
  <div v-if="$store.state.isIos" >
    <!--ios浏览器里面-->
      <div style="width: 100vw;background: transparent;" :style="{height:$store.state.bankHeight+'px'}"></div>
      <div style="width: 100vw;background: transparent;" :style="{height:$store.state.iosHeight+'px'}"></div>

  </div>
  <div v-else>
    <!--android浏览器里面-->
    <div style="width: 100vw;background: transparent;" :style="{height:$store.state.bankHeight+'px'}"></div>
  </div>
</template>

<script>
export default {
  name: 'bottomFixedBlank',
};
</script>



// WEBPACK FOOTER //
// bottomFixedBlank.vue